import React, { useState, useRef, useEffect } from "react";
import FreeToolsLayout from "./FreeToolsLayout";
import sparkleWhite from "~/images/sparkle-white.svg";
import sparklePurple from "~/images/sparkle-purple.svg";
import { generateKeywordClusters } from "../../api/freeToolsApis";
import GenerateResults from "../shared/GenerateResults";
const KeywordClustring = () => {
  const [keywords, setKeywords] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [clusters, setClusters] = useState([]);
  const resultRef = useRef(null);

  const handleGenerate = async () => {
    if (!keywords.trim()) {
      setError("Please enter some keywords");
      setShowResult(false);
      return;
    }

    setLoading(true);
    setError("");
    setShowResult(false);

    try {
      const response = await generateKeywordClusters(keywords);
      if (response.data) {
        setLoading(false);
        setClusters(response.data?.clusters || []);
        setShowResult(true);
      } else {
        throw new Error(response.data.error || "Failed to generate clusters");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const getButtonText = () => {
    if (loading) return "Generating...";
    if (clusters.length > 0) return "Generate Again";
    return "Generate";
  };

  useEffect(() => {
    if (clusters && resultRef.current) {
      resultRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [clusters]);
  return (
    <FreeToolsLayout mainHeading="AI Keyword Clustering Tool" subHeading="Group your keywords into semantically related clusters using AI">
      <div className="bg-white/70 rounded-[20px] p-[26px] shadow-md shadow-[#6248fe1f] relative min-h-[200px]">
        <textarea
          id="inputText"
          value={keywords}
          onChange={(e) => {
            setKeywords(e.target.value);
          }}
          className="w-full pr-16 bg-transparent border-none outline-none resize-none text-sm min-h-[120px] text-black placeholder-[#707070] focus:ring-0"
          placeholder="Enter your keywords (one per line)..."
        ></textarea>
        <GenerateResults loading={loading} handleGenerate={handleGenerate} text={getButtonText()} />
      </div>
      {error && <div className="text-red-600 text-sm px-2">{error}</div>}
      {showResult && (
        <div ref={resultRef}>
          <div className="flex items-center justify-center mb-4">
            <img src={sparklePurple} />
          </div>
          <div className="bg-white/70 rounded-[20px] p-[26px] shadow-md shadow-[#6248fe1f] relative min-h-[200px]">
            {clusters.map((cluster, index) => (
              <div key={index} class="p-4 rounded-lg border border-[#dfdaff] mb-4">
                <h3 class="text-lg font-semibold text-gray-900 mb-3">{cluster.name}</h3>
                <ul class="list-disc list-inside space-y-1">
                  {cluster.keywords.map((keyword) => (
                    <li class="text-gray-900 ml-5">{keyword}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </FreeToolsLayout>
  );
};

export default KeywordClustring;
